import { render, staticRenderFns } from "./postPage.vue?vue&type=template&id=25c4978b&scoped=true"
import script from "./postPage.vue?vue&type=script&lang=ts"
export * from "./postPage.vue?vue&type=script&lang=ts"
import style0 from "./postPage.vue?vue&type=style&index=0&id=25c4978b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c4978b",
  null
  
)

export default component.exports